import { Badge } from '@radix-ui/themes';
import { RadixColor } from 'enums/radix';
import { Currency } from 'lib/enums/currency';
import { useMemo } from 'react';

export const BadgeCurrency = (props: { value: Currency }) => {
  const color = useMemo<RadixColor>(() => {
    switch (props.value) {
      case Currency.CAD: {
        return 'red';
      }
      case Currency.USD: {
        return 'blue';
      }
      default: {
        return 'gray';
      }
    }
  }, [props.value]);

  return <Badge color={color}>{props.value.toUpperCase()}</Badge>;
};
